import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
     path: '',
     loadChildren: ()=> import('./session/session.module').then(m => m.SessionModule)
  },
  { 
    path: '', 
    loadChildren: ()=> import('./users/users.module').then(m => m.UsersModule)
  },
  {
    path: '**',
    redirectTo: 'login', 
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
